import axios from "axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
//import { eventHub } from './common/eventhub'
import store from "../store";
import deferred from "vue-deferred";

import { format } from "date-fns";
import { globalState } from "@/common/globalState";

import x2js from "x2js";

/*
    axios 인스턴스를 생성합니다.
    생성할때 사용하는 옵션들 (baseURL, timeout, headers 등)은 다음 URL에서 확인할 수 있습니다.
    https://github.com/axios/axios 의 Request Config 챕터 확인

*/
const instance = axios.create({
  timeout: 120000,
  baseURL: process.env == "test" ? "" : "",
  // headers: {'X-Custom-Header': 'foobar'}
});

/*
    1. 요청 인터셉터를 작성합니다.
    2개의 콜백 함수를 받습니다.
    1) 요청 바로 직전 - 인자값: axios config
    2) 요청 에러 - 인자값: error
*/
instance.interceptors.request.use(
  function (config) {
    // 요청 바로 직전
    // axios 설정값에 대해 작성합니다.
    globalState.isLoading = true;
    console.log("req success", config);
    return config;
  },
  function (error) {
    // 요청 에러 처리를 작성합니다.
    console.log("req error", error);
    return Promise.reject(error);
  }
);

/*
    2. 응답 인터셉터를 작성합니다.
    2개의 콜백 함수를 받습니다.
    1) 응답 정성 - 인자값: http response
    2) 응답 에러 - 인자값: http error
*/
instance.interceptors.response.use(
  function (response) {
    /*
          http status가 200인 경우
          응답 바로 직전에 대해 작성합니다. 
          .then() 으로 이어집니다.
      */

    globalState.isLoading = false;

    if (response.config.url == "/service/json.do") {
      //const data = new x2js().xml2js(response.data)
      let responseString = response.data.replace(/>\s+</g, "><");
      const data = new x2js().xml2js(responseString);

      const result = {
        svcId: data.teleMsg.header.rcvmsgSrvId,
        nErrorCode:
          Number(data.teleMsg.header.prcesResultDivCd) == 0
            ? 0
            : Number(data.teleMsg.header.prcesResultDivCd) * -1,
        msg: data.teleMsg.msg || {},
        body: data.teleMsg.body ? data.teleMsg.body : {},
      };
      // if (result.nErrorCode < 0) {
      //   router.push({ name: "Error" });
      // } else {
      return result;
      // }
    } else if (response.config.url == "/sessionRoute/getSessionUserInfo.do") {
      if (_.isEmpty(response.data.sessionUserInfo)) {
        router.push({
          name: "ErrorSessionExpired",
        });
      } else {
        return response;
      }
    } else {
      return response;
    }
  },

  function (error) {
    /*
        http status가 200이 아닌 경우
        응답 에러 처리를 작성합니다.
        .catch() 으로 이어집니다.    
    */
    globalState.isLoading = false;
    console.log("res error", error);
    return Promise.reject(error);
  }
);

// ajax methodsss
instance.json = async function (url = "", param = {}) {
  if (url == "") return Promise.reject("no Request URL");
  return await instance.post(url, param, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};
// 기간계 서비스 호출 메소드
instance.transaction = async function (
  serviceId = "",
  param = {},
  screenId = "CARGO0100"
) {
  const header = {
    encryDivCd: "0", //암호화구분코드
    globId: "", //글로벌ID
    rcvmsgSrvId: serviceId, //수신서비스ID
    esbIntfId: "FMOCUIS0001", //ESB 인터페이스ID
    resultRcvmsgSrvId: "", //결과수신서비스ID
    ipv6Addr1: "10.200.61.213", //IPV6주소1
    ipv6Addr2: "", //IPV6주소2
    teleMsgMacAdr: "309C23F099EE", //전문MAC주소
    envirInfoDivCd:
      window.location.hostname == "cargo.meritzfire.com" ? "P" : "D", //환경정보구분코드
    firstTranssLcatgBizafairCd: "AG", //최초전송대분류업무코드
    transsLcatgBizafairCd: "CD", //전송대분류업무코드
    reqRespnsDivCd: "Q", //요청응답구분코드
    syncDivCd: "S", //동기구분코드
    teleMsgReqDttm: format(new Date(), "yyyyMMddHHmmssSSS"), //전문요청일시
    prcesResultDivCd: "", //전문처리결과구분코드
    teleMsgRespnsDttm: "", //전문응답일시
    clienTrespnsDttm: "", //클라이언트응답일시
    handcapLcatgBizafairCd: "", //장애대분류업무코드
    teleMsgVerDivCd: "V01", //전문버전구분코드
    langDivCd: "KR", //언어구분코드
    belongGrpCd: "F", //소속그룹사코드
    empNo: "S00000005", //직원번호
    transGrpCd: "F", //거래그룹사코드
    screenId: screenId, //화면ID
    lowrnkScreenId: "", //하위화면ID
    dptCd: "", //부서코드
    hgrkDptCd: "", //상위부서코드
    nxupDptCd: "", //차상위부서코드
    empId: "", //직원ID
    dptId: "", //부서ID
    resveLet: "", //예비문자
  };

  const request = {
    teleMsg: {
      header: header,
      body: param,
      end: {},
    },
  };

  let url = "json";

  try {
    const result = await instance.json(`/service/${url}.do`, {
      body: request,
    });
    return result;
  } catch (e) {
    throw e;
  }
};

instance.reqPost = async function (url = "", param = {}) {
  if (url == "") return Promise.reject("no Request URL");

  const data = new URLSearchParams();
  for (const key in param) {
    data.append(key, param[key]);
  }

  return await instance.post(url, data.toString(), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
  });
};

instance.form = async function (url = "", formData) {
  if (url == "") return Promise.reject("no Request URL");

  return await instance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

instance.all = function (promiseList) {
  var defer = deferred();
  Promise.all(promiseList)
    .then(defer.resolve)
    .catch((error) => defer.reject(null));
  return defer.promise;
};

instance.download = async function (url) {
  return await axios
    .get(url, {
      responseType: "arraybuffer",
    })
    .then((response) => {
      console.log(response);
      let blob = new Blob([response.data], {
          type: "application/pdf",
        }),
        url = window.URL.createObjectURL(blob);

      window.open(url); // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
    });
};

// 생성한 인스턴스를 익스포트 합니다.
export default instance;
